import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        "flex h-12 w-full rounded-lg border border-[hsl(345,20%,85%)] bg-white px-4 py-3 text-base text-[hsl(0,0%,15%)] shadow-sm transition-all duration-300 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-[hsl(0,0%,50%)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[hsl(345,60%,35%)] focus-visible:border-[hsl(345,60%,35%)] disabled:cursor-not-allowed disabled:opacity-50 md:text-sm hover:border-[hsl(345,60%,35%)/0.5]",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
